export const formatNumberToSI = (num: number, options?: { digits?: number; space?: boolean }) => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'Q' }
  ]

  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/
  const item = lookup.findLast((item) => num >= item.value)

  return item
    ? (num / item.value)
        .toFixed(options?.digits ?? 0)
        .replace(regexp, '')
        .concat(options?.space ? ' ' : '', item.symbol)
    : '0'
}
